module.exports = __webpack_public_path__ + "media/images/videos/hero-6e409c0121c136dff05f5a9428c9d622.webm";